<div class="flex flex-col">
  <div class="flex items-center justify-between px-4 pt-4 pb-3">
    <h2 class="text-base font-semibold text-gray-900">{{ data.label }}</h2>
    <button
      type="button"
      (click)="onCancel()"
      [disabled]="isSubmitting()"
      class="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
      aria-label="Close"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <div class="px-4 pb-4">
    @if (data.sublabel) {
      <label class="mb-2 block text-sm text-gray-500" for="description">{{ data.sublabel }}</label>
    }
    @if (errorMessage) {
      <p class="mb-2 text-sm text-red-500">{{ errorMessage }}</p>
    }
    <textarea
      id="description"
      rows="8"
      placeholder="{{ data.placeholder }}"
      [(ngModel)]="comment"
      [disabled]="isSubmitting()"
      class="w-full resize-none rounded-lg border border-gray-200 p-4 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
    ></textarea>
  </div>

  <div class="flex flex-col gap-2 px-4 pb-4">
    <app-button [inputClass]="'!w-full !rounded-lg !py-2.5'" [loading]="isSubmitting()"
      [buttonDisabled]="isSubmitting()" (buttonClick)="onSubmit()">Submit</app-button>
    <app-button
      [inputClass]="'!w-full !rounded-lg !py-2.5 !bg-white !text-gray-700 !border !border-gray-300 hover:!bg-gray-50'"
      [buttonDisabled]="isSubmitting()" (buttonClick)="onCancel()"
    >Cancel</app-button>
  </div>
</div>
